import { render, staticRenderFns } from "./ZuidHolland.vue?vue&type=template&id=3f76ddfa&"
var script = {}
import style0 from "./ZuidHolland.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ZuidHolland.vue"
export default component.exports